<template>
  <div class="history-restore-loader">
    <div class="loader-content">
      <ProgressSpinner
        style="width: 50px; height: 50px"
        stroke-width="4"
        animation-duration="1s"
      />
      <div class="progress-info">
        <div class="progress-title">{{ t('templateBuilder.history.restoring') }}</div>
        <div class="progress-detail">
          <span class="progress-step">{{ current }} / {{ total }}</span>
          <span
            v-if="actionDetail"
            class="progress-action"
          >
            {{ t(`templateBuilder.history.${actionDetail}`) }}
          </span>
        </div>
        <ProgressBar
          :value="progressPercent"
          :show-value="false"
          class="progress-bar"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ProgressSpinner from 'primevue/progressspinner';
import ProgressBar from 'primevue/progressbar';

export default defineComponent({
  name: 'HistoryRestoreLoader',

  components: {
    ProgressSpinner,
    ProgressBar,
  },

  props: {
    current: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    actionDetail: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const { t } = useI18n();

    const progressPercent = computed(() => {
      if (props.total === 0) return 0;
      return Math.round((props.current / props.total) * 100);
    });

    return {
      t,
      progressPercent,
    };
  },
});
</script>

<style lang="scss" scoped>
.history-restore-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1102;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 250px;
}

.progress-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}

.progress-title {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.progress-detail {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.85rem;
  color: #666;
}

.progress-step {
  font-weight: 500;
}

.progress-action {
  font-size: 0.75rem;
  color: #888;
  text-align: center;
}

.progress-bar {
  width: 100%;
  height: 6px;
  margin-top: 0.5rem;

  :deep(.p-progressbar-value) {
    background: $brand-color-primary;
  }
}
</style>
